import React from 'react';
import { UserCheck } from 'lucide-react';

interface NavbarProps {
  onOpenSignatoryModal?: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ onOpenSignatoryModal }) => {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-30 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img
              src="/mwa_logo.png"
              alt="ตราสัญลักษณ์ การประปานครหลวง"
              className="w-10 h-10 sm:w-11 sm:h-11 object-contain drop-shadow-sm flex-shrink-0"
            />
            <div>
              <div className="flex items-center gap-2">
                <h1 className="text-lg font-bold text-slate-800 leading-tight">
                  ระบบรายงานข้อมูลสารเคมี
                </h1>
                <span className="hidden sm:inline-block px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-50 text-blue-700 border border-blue-200">
                  MWA Mahasawat
                </span>
              </div>
              <p className="text-xs text-slate-500 hidden sm:block">
                โรงงานผลิตน้ำมหาสวัสดิ์ • การประปานครหลวง
              </p>
            </div>
          </div>

          {onOpenSignatoryModal && (
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={onOpenSignatoryModal}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-700 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-lg transition-colors cursor-pointer shadow-2xs"
                title="ตั้งค่ารายชื่อและตำแหน่งผู้ลงนาม 4 คนท้ายรายงาน"
              >
                <UserCheck className="w-4 h-4 text-blue-600" />
                <span className="hidden sm:inline">ตั้งค่าผู้ลงนาม (4 คน)</span>
                <span className="sm:hidden">ผู้ลงนาม</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

